import './default_module'

/* stylesheet */

jQuery(() => {
  $('[name="products[]"]').change(function() {
    // set the disabled state of :not(:checked) checkboxes based on the number of :checked
    $('[name="products[]"]:not(:checked)').prop('disabled', $('[name="products[]"]:checked').length > 2);
  });

});
